
import Experience from '../components/Experience';
import Footer from '../components/Footer';
import Hero from '../components/Hero';
import Navbar from '../components/Navbar';
import Projects from '../components/Projects';

export default function Home ({ darkMode, switchColourMode }) {
    
    return (
        <div className={`flex flex-col justify-between ${darkMode ? 'dark' : ''}`}>
            <Navbar darkMode={darkMode} switchColourMode={switchColourMode} />
            <Hero />
            <Experience />
            <Projects darkMode={darkMode} />
            <Footer />
        </div>
    )
}